import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App, { database } from './App';
import Overlay from './Overlay';
import reportWebVitals from './reportWebVitals';

// Opened inside Discord as an Activity (Discord adds frame_id): just Cheeky Dash. Loaded only then, so the site
// doesn't carry Discord's SDK
const CheekyDashActivity = React.lazy(() => import('./CheekyDashActivity'));
const inDiscord = new URLSearchParams(window.location.search).has('frame_id');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* /overlay is the see-through page for OBS: none of the site around it */}
    {inDiscord ? <React.Suspense fallback={null}><CheekyDashActivity /></React.Suspense>
      : window.location.pathname.replace(/\/$/, '') === '/overlay' ? <Overlay database={database} /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
